import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import ImageUploadRow from './ImageUploadRow';


const GET_TRASH_STATUS = gql`
  query getTrashStatus($id: ID!, $filename: String!) {
    medium(id: $id, filename: $filename) {
      id
      trash
    }
  }
`;

const ImageUploadRowForBG = ({
  id,
  name,
  trash,
  image,
  ...props
}) => {
  const { data } = useQuery(GET_TRASH_STATUS, { variables:
    { id, filename: name },
  ssr: false });

  let trashed;
  let imagePreview = image;

  if (!data) {
    trashed = trash;
  }


  if (data && id) {
    trashed = data?.medium?.trash;
    if (!data.medium) {
      imagePreview = (
        <img
          src={undefined}
          alt="thumbnail"
        />
      );
    }
  }

  return (
    <ImageUploadRow
      {...props}
      name={name}
      trash={trashed}
      image={imagePreview}
    />
  );
};

export default ImageUploadRowForBG;
